import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmClientService {
  private apiEndpoint: string = '/api/crm/clients';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getClients(): Observable<any> {
    const requestObject = {
      API_URL: this.apiEndpoint,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
  }

  getClientById(id: number): Observable<any> {
    const requestObject = {
      API_URL: `${this.apiEndpoint}/${id}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
  }

  createClient(clientData: any, userEmail: string): Observable<any> {
    const requestObject = {
      API_URL: `${this.apiEndpoint}?userEmail=${encodeURIComponent(userEmail || '')}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: clientData
    };
    return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
  }

  updateClient(id: number, clientData: any, userEmail: string): Observable<any> {
    const requestObject = {
      API_URL: `${this.apiEndpoint}/${id}?userEmail=${encodeURIComponent(userEmail || '')}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: clientData
    };
    return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
  }

  private extractData(res: any) {
    return res || {};
  }
}
